import { SVGProps } from 'react';

interface DuplicateAndMoveProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

const DuplicateAndMove = ({ size = 17, ...props }: DuplicateAndMoveProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
      />
      <path
        fill="currentColor"
        d="M10,13 H13.5 V11 L16.5,14 L13.5,17 V15 H10 Z"
      />
    </svg>
  );
};

export default DuplicateAndMove;
